module.exports = __webpack_public_path__ + "img/ben_highlight.684b8dd6.png";